// extracted by mini-css-extract-plugin
export default {"wrap_temperature_box":"TemperaturePanel_wrap_temperature_box__-XWU-","wrapper":"TemperaturePanel_wrapper__qMwtl","one_temp_box":"TemperaturePanel_one_temp_box__4qzmr"};